import ForgotPassword, {
	action as handleForgotPassword,
	loader as questionsLoader,
} from './ForgotPassword';

export default ForgotPassword;
export { handleForgotPassword, questionsLoader };
